import { useSyncExternalStore } from 'react'
import { WifiOff } from 'lucide-react'

function subscribe(cb: () => void) {
  window.addEventListener('online', cb)
  window.addEventListener('offline', cb)
  return () => {
    window.removeEventListener('online', cb)
    window.removeEventListener('offline', cb)
  }
}

function useOnline() {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true)
}

/** Reservations are never promised offline: we say so clearly. */
export function OfflineBanner() {
  const online = useOnline()
  if (online) return null
  return (
    <div role="alert" className="sticky top-0 z-[70] flex items-center justify-center gap-2 bg-foreground px-4 py-2 text-center text-sm text-background">
      <WifiOff className="size-4" aria-hidden />
      Sin conexión. Puedes ver la información guardada, pero no se pueden hacer ni confirmar reservas.
    </div>
  )
}
